var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"sortable-th",class:{ asc: _vm.active && _vm.ascending, desc: _vm.active && _vm.descending },on:{"click":function($event){return _vm.$emit('clicked', _vm.name)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }